import React from 'react'
import ReactDOM from 'react-dom/client'
import { ConvexReactClient } from 'convex/react'
import { ConvexAuthProvider } from '@convex-dev/auth/react'
import App from './App'
import './index.css'

// Debug logging to identify the issue
console.log('🔧 App starting...', {
  convexUrl: import.meta.env.VITE_CONVEX_URL,
  mode: import.meta.env.MODE,
  allViteEnvs: Object.keys(import.meta.env).filter(k => k.startsWith('VITE_'))
});

const convex = new ConvexReactClient(import.meta.env.VITE_CONVEX_URL as string);
console.log('✅ ConvexReactClient created');

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ConvexAuthProvider client={convex}>
      <App />
    </ConvexAuthProvider>
  </React.StrictMode>
)
console.log('✅ React render called');